"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chains = void 0;
const tslib_1 = require("tslib");
const AlfajoresDefinition = tslib_1.__importStar(require("./data/alfajores"));
const ArbitrumOneDefinition = tslib_1.__importStar(require("./data/arbitrum-one"));
const ArbitrumRinkebyDefinition = tslib_1.__importStar(require("./data/arbitrum-rinkeby"));
const AvalancheDefinition = tslib_1.__importStar(require("./data/avalanche"));
const BscDefinition = tslib_1.__importStar(require("./data/bsc"));
const BscTestDefinition = tslib_1.__importStar(require("./data/bsctest"));
const CeloDefinition = tslib_1.__importStar(require("./data/celo"));
const CoreDefinition = tslib_1.__importStar(require("./data/core"));
const FantomDefinition = tslib_1.__importStar(require("./data/fantom"));
const FuseDefinition = tslib_1.__importStar(require("./data/fuse"));
const GoerliDefinition = tslib_1.__importStar(require("./data/goerli"));
const MainnetDefinition = tslib_1.__importStar(require("./data/mainnet"));
const MantleDefinition = tslib_1.__importStar(require("./data/mantle"));
const MantleTestnetDefinition = tslib_1.__importStar(require("./data/mantle-testnet"));
const MaticDefinition = tslib_1.__importStar(require("./data/matic"));
const MoonbeamDefinition = tslib_1.__importStar(require("./data/moonbeam"));
const MumbaiDefinition = tslib_1.__importStar(require("./data/mumbai"));
const OptimismDefinition = tslib_1.__importStar(require("./data/optimism"));
const PrivateDefinition = tslib_1.__importStar(require("./data/private"));
const RinkebyDefinition = tslib_1.__importStar(require("./data/rinkeby"));
const RoninDefinition = tslib_1.__importStar(require("./data/ronin"));
const SokolDefinition = tslib_1.__importStar(require("./data/sokol"));
const TombchainDefinition = tslib_1.__importStar(require("./data/tombchain"));
const XDaiDefinition = tslib_1.__importStar(require("./data/xdai"));
const SepoliaDefinition = tslib_1.__importStar(require("./data/sepolia"));
const ZkSyncEraTestnetDefinition = tslib_1.__importStar(require("./data/zksync-era-testnet"));
const ZkSyncEraDefinition = tslib_1.__importStar(require("./data/zksync-era"));
exports.chains = {
    alfajores: AlfajoresDefinition,
    'arbitrum-one': ArbitrumOneDefinition,
    'arbitrum-rinkeby': ArbitrumRinkebyDefinition,
    avalanche: AvalancheDefinition,
    bsc: BscDefinition,
    bsctest: BscTestDefinition,
    celo: CeloDefinition,
    core: CoreDefinition,
    fantom: FantomDefinition,
    fuse: FuseDefinition,
    goerli: GoerliDefinition,
    mainnet: MainnetDefinition,
    mantle: MantleDefinition,
    'mantle-testnet': MantleTestnetDefinition,
    matic: MaticDefinition,
    moonbeam: MoonbeamDefinition,
    mumbai: MumbaiDefinition,
    optimism: OptimismDefinition,
    private: PrivateDefinition,
    rinkeby: RinkebyDefinition,
    ronin: RoninDefinition,
    sokol: SokolDefinition,
    tombchain: TombchainDefinition,
    xdai: XDaiDefinition,
    sepolia: SepoliaDefinition,
    zksynceratestnet: ZkSyncEraTestnetDefinition,
    zksyncera: ZkSyncEraDefinition,
};
